import { BonusPoints } from "../../../api/bonus.types";
import { BonusPointsAction } from "./bonus.points.types";

export const bonusPointsRequestAction = (params?: { bonus_code: string }): BonusPointsAction => ({ type: 'BONUS_POINTS_REQUEST', params })

export const bonusPointsSuccessAction = (points: BonusPoints): BonusPointsAction => ({ type: 'BONUS_POINTS_SUCCESS', params: points })

export const bonusPointsFailureAction = (error?: any) => ({ type: 'BONUS_POINTS_FAILURE' } as const)